var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSprite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "hidden",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "notify",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.454 8.004a7.567 7.567 0 0 1 15.092 0l.426 5.711L19.382 18h-6.553a3 3 0 0 1-5.658 0H.618l1.41-4.285.426-5.711ZM10 3a5.567 5.567 0 0 0-5.552 5.153l-.444 5.955L3.382 16h13.236l-.622-1.892-.444-5.955A5.567 5.567 0 0 0 10 3Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_small",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10 10.72-4.375-3.5-1.25 1.56L10 13.28l5.625-4.5-1.25-1.56L10 10.72Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.683 3.65 6.24l-1.3 1.518L10 14.317l7.65-6.558-1.3-1.518L10 11.683Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8H7V6h10v2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM2 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM13 14H3v-2h10v2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "eye_hide",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1904_8690)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5c-.364 0-.721.021-1.071.062l-.233-1.986C9.124 3.026 9.56 3 10 3c4.555 0 8.474 2.748 9.936 6.649l.131.351-.131.35a9.92 9.92 0 0 1-2.223 3.468l-1.426-1.402A7.96 7.96 0 0 0 17.922 10C16.663 7.091 13.61 5 10 5Zm-7.922 5a8.013 8.013 0 0 1 1.991-2.758L2.73 5.758A9.971 9.971 0 0 0 .063 9.649L-.068 10l.131.35C1.525 14.253 5.443 17 10 17c.752 0 1.488-.075 2.197-.218l-.394-1.96A9.135 9.135 0 0 1 10 15c-3.611 0-6.664-2.091-7.922-5ZM3.293 3.293a1 1 0 0 1 1.414 0l12 12a1 1 0 0 1-1.414 1.414l-12-12a1 1 0 0 1 0-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.024 9.56a4 4 0 0 0 4.416 4.416L6.024 9.56ZM13.976 10.44A4 4 0 0 0 9.56 6.024l4.417 4.418Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1904_8690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_2",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.317 10 5.442-6.35-1.518-1.3L.683 10l6.558 7.65 1.518-1.3L3.317 10Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11H2V9h18v2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bag",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4h18v14H1V4Zm2 2v10h14V6H3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5h16v2H2v-2ZM8 12.5h4v2H8v-2ZM8 5a2 2 0 1 1 4 0h2a4 4 0 0 0-8 0h2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.717 13.32C5.158 13.778 5 14.352 5 14.953V15h10v-.046c0-.602-.159-1.176-.717-1.634-.604-.495-1.83-.987-4.283-.987-2.453 0-3.68.492-4.283.987ZM4.45 11.773c1.12-.917 2.893-1.44 5.551-1.44 2.658 0 4.432.523 5.55 1.44 1.164.954 1.45 2.19 1.45 3.18V16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.046c0-.991.286-2.227 1.45-3.181ZM10 4a1.667 1.667 0 1 0 0 3.333A1.667 1.667 0 0 0 10 4ZM6.335 5.667a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user_ok",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.717 13.32C2.158 13.778 2 14.352 2 14.953V15h10v-.046c0-.602-.159-1.176-.717-1.634-.604-.495-1.83-.987-4.283-.987-2.453 0-3.68.492-4.283.987ZM1.45 11.773c1.12-.917 2.893-1.44 5.551-1.44 2.658 0 4.432.523 5.55 1.44 1.164.954 1.45 2.19 1.45 3.18V16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1.046c0-.991.286-2.227 1.45-3.181ZM7 4a1.667 1.667 0 1 0 0 3.333A1.667 1.667 0 0 0 7 4ZM3.335 5.667a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0ZM15 8.586l3.293-3.293 1.414 1.414-4 4a1 1 0 0 1-1.414 0l-2-2 1.414-1.414L15 8.586Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user_add",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11V4h2v7h-2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.5h7v2h-7v-2ZM2.717 13.32C2.158 13.778 2 14.352 2 14.953V15h10v-.046c0-.602-.159-1.176-.717-1.634-.604-.495-1.83-.987-4.283-.987-2.453 0-3.68.492-4.283.987ZM1.45 11.773c1.12-.917 2.893-1.44 5.551-1.44 2.658 0 4.432.523 5.55 1.44 1.164.954 1.45 2.19 1.45 3.18V16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1.046c0-.991.286-2.227 1.45-3.181ZM7 4a1.667 1.667 0 1 0 0 3.333A1.667 1.667 0 0 0 7 4ZM3.333 5.667a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user_multi",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.717 13.32C2.158 13.778 2 14.352 2 14.953V15h10v-.046c0-.602-.159-1.176-.717-1.634-.604-.495-1.83-.987-4.283-.987-2.453 0-3.68.492-4.283.987ZM1.45 11.773c1.12-.917 2.893-1.44 5.551-1.44 2.658 0 4.432.523 5.55 1.44 1.164.954 1.45 2.19 1.45 3.18V16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1.046c0-.991.286-2.227 1.45-3.181ZM7 4a1.667 1.667 0 1 0 0 3.333A1.667 1.667 0 0 0 7 4ZM3.335 5.667a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13c-.962 0-1.694.095-2.247.24a1 1 0 0 1-.506-1.935C12.005 11.106 12.914 11 14 11c2.238 0 3.766.452 4.742 1.275 1.015.856 1.258 1.96 1.258 2.828V16a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h8.998c-.017-.456-.154-.866-.545-1.196C16.993 13.417 16.022 13 14 13ZM14 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.157 10A8.611 8.611 0 0 0 10 15a8.611 8.611 0 0 0 7.843-5A8.611 8.611 0 0 0 10 5a8.611 8.611 0 0 0-7.843 5ZM20 10c-1.456-4.078-5.383-7-10-7S1.456 5.922 0 10c1.456 4.078 5.383 7 10 7s8.544-2.922 10-7Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "italic",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 4-2.64 12H7L9.64 4H13Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "underline",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.025 4h2.108v6.65c0 .747-.173 1.4-.52 1.96-.345.56-.827.997-1.447 1.31-.62.31-1.342.465-2.166.465-.828 0-1.551-.155-2.171-.465a3.516 3.516 0 0 1-1.446-1.31c-.344-.56-.516-1.213-.516-1.96V4h2.108v6.465c0 .39.082.737.248 1.04.169.303.406.542.71.715.306.173.661.26 1.067.26.409 0 .764-.087 1.066-.26.305-.173.54-.412.706-.715.169-.303.253-.65.253-1.04V4ZM5 16.04h10V17H5v-.96Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "list",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8H8V6h10v2ZM18 14H8v-2h10v2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "number_list",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8H8V6h10v2ZM18 14H8v-2h10v2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.024 5v3.636h-.987V5.91h-.021l-.796.476v-.838L4.115 5h.91ZM3.241 14.686v-.71l1.357-1.122c.09-.075.167-.145.23-.21a.795.795 0 0 0 .15-.204.506.506 0 0 0 .053-.233.453.453 0 0 0-.06-.24.391.391 0 0 0-.164-.152.512.512 0 0 0-.241-.055.512.512 0 0 0-.241.055.382.382 0 0 0-.16.162.545.545 0 0 0-.057.259H3.17c0-.256.058-.476.173-.66.114-.185.277-.327.486-.427.21-.1.455-.149.737-.149.291 0 .543.047.756.14.215.093.38.223.496.39a1.072 1.072 0 0 1 .089 1.008c-.058.139-.163.29-.313.458-.15.167-.364.365-.64.596l-.342.284v.022h1.42v.788h-2.79Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bold",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 16V4h5.19c.954 0 1.749.13 2.386.393.637.261 1.116.625 1.437 1.09.32.46.48.992.48 1.593 0 .469-.1.881-.303 1.237-.203.351-.481.64-.836.867-.35.222-.75.38-1.202.474v.117c.494.02.956.149 1.386.387.435.239.787.572 1.057 1.002.27.426.405.934.405 1.524a2.95 2.95 0 0 1-.513 1.705c-.337.496-.837.888-1.5 1.177-.662.29-1.479.434-2.449.434H5Zm2.74-2.074h2.235c.763 0 1.32-.135 1.67-.405.35-.273.526-.636.526-1.09 0-.331-.087-.624-.26-.878a1.728 1.728 0 0 0-.74-.598c-.317-.145-.694-.217-1.133-.217H7.741v3.188Zm0-4.905h2.032c.376 0 .709-.06 1-.181.296-.125.528-.3.696-.527.173-.227.26-.499.26-.815 0-.434-.167-.783-.5-1.049-.33-.265-.798-.398-1.405-.398H7.74v2.97Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "add",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9h10v2H5V9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15V5h2v10H9Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5h14v2H3V5Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9h2v2H5V9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9v2h2V9H5Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13h2v2H5v-2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13v2h2v-2H5Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h2v2H9V9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9v2h2V9H9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13h2v2H9v-2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13v2h2v-2H9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h2v2h-2V9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9v2h2V9h-2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13h2v2h-2v-2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13v2h2v-2h-2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.5h18v15H1v-15Zm2 2v11h14v-11H3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.844 6.094 9.375 9.72a1 1 0 0 0 1.25 0l4.531-3.626 1.25 1.562-4.532 3.625a3 3 0 0 1-3.748 0L3.594 7.656l1.25-1.562Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9h14v9H3V9Zm2 2v5h10v-5H5Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5a4 4 0 1 1 8 0v6H6V5Zm4-2a2 2 0 0 0-2 2v4h4V5a2 2 0 0 0-2-2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-9 7a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5h2v4h3.5v2H9V5Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "file_add",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3a4 4 0 0 0-4 4v7.667a2.333 2.333 0 0 0 4.667 0v-5.91a.667.667 0 0 0-1.334 0v5.607h-2V8.758a2.667 2.667 0 1 1 5.334 0v5.909a4.333 4.333 0 0 1-8.667 0V7a6 6 0 1 1 12 0v4.454h-2V7a4 4 0 0 0-4-4ZM14.5 14.5V12h2v2.5H19v2h-2.5V19h-2v-2.5H12v-2h2.5Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "file",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3a4 4 0 0 0-4 4v7.667a2.333 2.333 0 0 0 4.667 0v-5.91a.667.667 0 0 0-1.334 0v5.607h-2V8.758a2.667 2.667 0 1 1 5.334 0v5.909a4.333 4.333 0 0 1-8.667 0V7a6 6 0 1 1 12 0v4.454h-2V7a4 4 0 0 0-4-4Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "delete",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.874 5.888 6.087 16h7.826l1.213-10.112 1.986.238-1.32 10.993A1 1 0 0 1 14.8 18H5.2a1 1 0 0 1-.993-.88L2.888 6.125l1.986-.238ZM2 3h16v2H2V3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "more",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM18 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "business",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1h10v5h8v13H1V1Zm2 2v14h14V8H9V3H3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8V5h2v3H5ZM5 13v-3h2v3H5ZM9 13v-3h2v3H9ZM13 13v-3h2v3h-2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15h6v4H7v-4Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "business_add",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1h10v5h8v5h-2V8H9V3H3v14h8v2H1V1Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8V5h2v3H5ZM5 13v-3h2v3H5ZM9 13v-3h2v3H9ZM19 16h-8v-2h8v2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11v8h-2v-8h2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.293 17.707-6-6 1.414-1.414 6 6-1.414 1.414Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "doc",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8804)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1h16v18H2V1Zm2 2v14h12V3H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 7-5-5v5h5Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8804"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "doc_add",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8818)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1h16v9h-2V3H4v14h6v2H2V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16h-8v-2h8v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11v8h-2v-8h2ZM17 7l-5-5v5h5Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8818"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "archives",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8835)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h4.5v2H4v12h12V4h-2.5V2H18v16H2V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2v11H9V2h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.723 9.613 10 11.798l3.277-2.185 1.11 1.664-3.832 2.555a1 1 0 0 1-1.11 0l-3.832-2.555 1.11-1.664Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8835"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "like",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V8Zm2 1v7h2V9H3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49 1.277A1 1 0 0 1 10.183 1H12a1 1 0 0 1 .97 1.243L12.28 5H16a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a1 1 0 0 1-1-1V7.71a5 5 0 0 1 1.544-3.614L9.49 1.277ZM10.584 3 7.926 5.541A3 3 0 0 0 7 7.71V16h9a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-5a1 1 0 0 1-.97-1.243L10.72 3h-.137Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "dislike",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v9Zm-2-1V4h-2v7h2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.51 18.723a1 1 0 0 1-.692.277H8a1 1 0 0 1-.97-1.242L7.72 15H4a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h10a1 1 0 0 1 1 1v9.29a5 5 0 0 1-1.544 3.614l-2.947 2.819ZM9.416 17l2.657-2.541A3 3 0 0 0 13 12.29V4H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 1 .97 1.242L9.28 17h.137Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "info",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8859)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.468 5-.346 5.613H8.918L8.572 5h2.896ZM8.5 13.452c0-.44.14-.806.418-1.099.28-.3.641-.449 1.086-.449.445 0 .804.15 1.078.45.279.292.418.659.418 1.098 0 .44-.14.81-.418 1.108-.274.293-.633.44-1.078.44-.445 0-.807-.146-1.086-.44-.279-.299-.418-.668-.418-1.108Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-9 7a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8859"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_link",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8873)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.895 14.45 9.64-9.641 1.415 1.414-9.641 9.64-1.414-1.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.426 10.942.02-4.629-4.63.02-.008-2 5.637-.024a1 1 0 0 1 1.005 1.004l-.024 5.637-2-.008Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8873"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "exit",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8885)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H7v2.5a1 1 0 1 0 2 0V4h8v12H9v-1a1 1 0 1 0-2 0v3h12V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10 4.8 6.6 3.2 5.4-.25 10l3.45 4.6 1.6-1.2L2.25 10Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8885"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "refresh",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4a6 6 0 1 0 6 6V9h2v1a8 8 0 1 1-2.027-5.322l.665.746-1.492 1.331-.666-.746A5.983 5.983 0 0 0 10 4Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.771 5.139-3.976.832.41 1.958 5.727-1.199-.554-5.825-1.99.19.383 4.044Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tik_all_read",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.414 5.968-8.338 8.723a1 1 0 0 1-1.6-.212L.642 9.294l1.755-.959 2.177 3.985 7.393-7.734 1.446 1.382ZM19.414 5.968l-8.338 8.723a1 1 0 0 1-1.6-.212l-1.068-1.954 1.755-.959.412.754 7.393-7.734 1.446 1.382Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pin",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19 3.24a7.412 7.412 0 0 1 10.62 0c2.92 2.978 2.92 7.797 0 10.774L9.5 19.428l-5.31-5.414c-2.92-2.977-2.92-7.796 0-10.773Zm9.192 1.401a5.412 5.412 0 0 0-7.764 0c-2.157 2.2-2.157 5.773 0 7.973L9.5 16.572l3.882-3.958c2.157-2.2 2.157-5.773 0-7.973Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "picture",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3Zm2 1v12h14V4H3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3Zm2 1v12h14V4H3Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8a1 1 0 0 1 .848.47l5 8a1 1 0 0 1-1.696 1.06L7 10.887 2.848 17.53a1 1 0 0 1-1.696-1.06l5-8A1 1 0 0 1 7 8Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8a1 1 0 0 1 .848.47l5 8a1 1 0 0 1-1.696 1.06L7 10.887 2.848 17.53a1 1 0 0 1-1.696-1.06l5-8A1 1 0 0 1 7 8Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 12a1 1 0 0 1 .848.47l2.5 4a1 1 0 0 1-1.696 1.06L13.5 14.887l-1.652 2.643a1 1 0 0 1-1.696-1.06l2.5-4A1 1 0 0 1 13.5 12ZM13 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "heart",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.588 4.461c-1.246-1.281-3.018-1.281-4.263 0L10.063 6.79 7.96 4.627c-1.226-1.261-3.438-1.261-4.664 0-.761.784-.93 1.645-.706 2.636.24 1.056.933 2.244 1.924 3.474 1.73 2.147 4.14 4.15 5.762 5.468 1.527-1.282 3.804-3.27 5.41-5.419.926-1.238 1.561-2.443 1.753-3.526.18-1.023-.026-1.949-.852-2.799ZM10.89 3.067c2.032-2.09 5.1-2.09 7.132 0 1.319 1.357 1.668 2.95 1.387 4.541-.27 1.53-1.116 3.032-2.12 4.375-1.961 2.625-4.788 4.975-6.254 6.194l-.11.092-.632.526-.638-.519-.313-.254c-1.592-1.288-4.387-3.552-6.384-6.03C1.893 10.672.98 9.2.641 7.705c-.354-1.56-.073-3.14 1.222-4.472 2.012-2.07 5.521-2.07 7.533 0l.666.686.828-.852Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8961)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.636 1.586 3.778 3.778L5.736 18.042l-3.439-.34-.339-3.438L14.636 1.586Zm0 2.828L4.042 15.01l.085.864.864.085L15.586 5.364l-.95-.95Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8961"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "link",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.05 3.95a3.247 3.247 0 0 0-5.188 3.774l2.185-2.185 1.414 1.415-2.185 2.184a3.248 3.248 0 0 0 3.773-5.187Zm-5.232 6.646a5.248 5.248 0 0 0 6.645-8.06 5.246 5.246 0 0 0-8.06 6.646l-.22.222a5.248 5.248 0 0 0-6.646 8.06 5.247 5.247 0 0 0 8.06-6.646l.221-.222Zm-3.094.266L5.54 13.046l1.414 1.415 2.184-2.185a3.248 3.248 0 0 1-5.187 3.773 3.247 3.247 0 0 1 3.773-5.187Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8969"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "linkedin",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 17H2.2V6.3h3.4V17ZM3.9 4.8C2.8 4.8 2 4 2 2.9 2 1.8 2.9 1 3.9 1c1.1 0 1.9.8 1.9 1.9C5.8 4 5 4.8 3.9 4.8ZM18 17h-3.4v-5.8c0-1.7-.7-2.2-1.7-2.2s-2 .8-2 2.3V17H7.5V6.3h3.2v1.5C11 7.1 12.2 6 13.9 6c1.9 0 3.9 1.1 3.9 4.4V17h.2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8988"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_8996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9.836c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 4 2.9 7.3 6.7 7.9v-5.6h-2v-2.3h2v-1.8c0-2 1.2-3.1 3-3.1.9 0 1.8.2 1.8.2v2h-1c-1 0-1.3.6-1.3 1.2v1.5h2.2l-.4 2.3h-1.9v5.7c4-.6 6.9-4 6.9-8Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_8996"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.836c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-2.1 0-3.7 2-3.2 4-2.7-.1-5.1-1.4-6.8-3.4-.9 1.5-.4 3.4 1 4.4-.5 0-1-.2-1.5-.4 0 1.5 1.1 2.9 2.6 3.3-.5.1-1 .2-1.5.1.4 1.3 1.6 2.3 3.1 2.3-1.2.9-3 1.4-4.7 1.2 1.5.9 3.2 1.5 5 1.5 6.1 0 9.5-5.1 9.3-9.8.7-.4 1.3-1 1.7-1.7Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9004"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "tel",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9013)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9013"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.415 10 5.292 5.292-1.414 1.415L10 11.414l-5.293 5.293-1.414-1.415L8.586 10 3.294 4.708l1.414-1.415 5.293 5.293 5.292-5.293 1.414 1.415L11.415 10Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "notes",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9036)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h16v16H2V2Zm2 2v12h12V4H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 12-5 5v-5h5Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9036"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "pipeline",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9047)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3h10.72l2.334 7-2.333 7H1V3Zm2 2v10h7.28l1.666-5-1.667-5H3ZM16.633 2.735 19.053 10l-2.421 7.265-1.898-.633L16.945 10l-2.21-6.632 1.898-.633Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9047"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "inbox",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9061)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11a1 1 0 0 1 1-1h5.17a1 1 0 0 1 .944.667 2.001 2.001 0 0 0 3.772 0A1 1 0 0 1 12.83 10H18a1 1 0 0 1 1 1v4a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-4Zm2 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3h-3.535A3.998 3.998 0 0 1 10 14a3.998 3.998 0 0 1-3.465-2H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.642 3.734A3 3 0 0 1 4.63 1h10.74a3 3 0 0 1 2.988 2.734l.638 7.178-1.992.176-.638-7.177A1 1 0 0 0 15.37 3H4.63a1 1 0 0 0-.996.911l-.638 7.178-1.992-.178.638-7.177Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9061"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.039.956a4 4 0 0 1 3.922 0l5 2.812A4 4 0 0 1 19 7.255v5.49a4 4 0 0 1-2.039 3.487l-5 2.812a4 4 0 0 1-3.922 0l-5-2.812A4 4 0 0 1 1 12.745v-5.49a4 4 0 0 1 2.039-3.487l5-2.812Zm2.941 1.743a2 2 0 0 0-1.96 0l-5 2.812A2 2 0 0 0 3 7.255v5.49a2 2 0 0 0 1.02 1.744l5 2.812a2 2 0 0 0 1.96 0l5-2.812A2 2 0 0 0 17 12.745v-5.49a2 2 0 0 0-1.02-1.744l-5-2.812Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9097)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14v2h12v-2h2v4H2v-4h2ZM11 2v11H9V2h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.723 9.613 10 11.798l3.277-2.185 1.11 1.664-3.832 2.555a1 1 0 0 1-1.11 0l-3.832-2.555 1.11-1.664Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9097"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "crm",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_9114)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7v5H9V7h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.414 12-2.707 2.707-1.414-1.414L9 10.586 10.414 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.586 12 2.707 2.707 1.414-1.414L11 10.586 9.586 12ZM10 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM5 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_9114"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "tik",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.274 13.539 6.929-9.143 1.594 1.208-8.229 10.857-5.228-4.599 1.32-1.502 3.614 3.179Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "doc_add_100",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 60.5H47v-2h13v2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 53v13h-2V53h2Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 29h32v42H33V29Zm2 2v38h28V31H35Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m65 38-9-9v9h9Zm-4.828-2L58 33.828V36h2.172Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user_multi_100",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.572 36a5.857 5.857 0 1 0 0 11.714 5.857 5.857 0 0 0 0-11.714Zm-7.858 5.857a7.857 7.857 0 1 1 15.715 0 7.857 7.857 0 0 1-15.715 0Zm24.209-2.362a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm-20.637 12.38C29.488 58.435 29 60.437 29 62.308V64h27.143v-1.691c0-1.372-.262-2.815-1.112-4.102a6.68 6.68 0 0 0-1.541-1.63C51.588 55.126 48.279 54 42.571 54c-6.093 0-9.453 1.284-11.284 2.874ZM53.329 54.1c-2.403-1.306-5.861-2.1-10.757-2.1-6.32 0-10.245 1.323-12.596 3.364C27.592 57.432 27 60.084 27 62.309V65a1 1 0 0 0 1 1h43.253a1 1 0 0 0 1-1v-2.307c0-1.94-.534-4.263-2.677-6.07-2.104-1.774-5.596-2.909-11.18-2.909-1.936 0-3.614.136-5.068.386Zm4.815 8.209c0-1.389-.231-2.945-.985-4.422a8.23 8.23 0 0 0-1.5-2.065c.836-.07 1.746-.108 2.738-.108 5.368 0 8.304 1.1 9.89 2.438 1.549 1.306 1.967 2.972 1.967 4.541V64h-12.11v-1.691Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "business_100",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 29h23.5v5H68v6.813h4V71H28V29Zm17 40h4v-8h-4v8Zm-2-10v10H30V34h19.5v8.813H70V69H57V59H43Zm8 2v8h4v-8h-4Zm-1.5-29v-1H30v1h19.5ZM66 40.813V36h-2v4.813h2Zm-4 0V36h-2v4.813h2Zm-4 0V36h-2v4.813h2Zm-4 0V36h-2.5v4.813H54ZM34 43v-5h2v5h-2Zm5 0v-5h2v5h-2Zm5 0v-5h2v5h-2Zm-10 9v-5h2v5h-2Zm5 0v-5h2v5h-2Zm5 0v-5h2v5h-2Zm5 0v-5h2v5h-2Zm5 0v-5h2v5h-2Zm5 0v-5h2v5h-2Zm5 0v-5h2v5h-2Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "notify_100",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.756 42.602a12.492 12.492 0 0 1 24.066 6.449l-1.883 9.937.389 6.938-10.619-2.845a4.501 4.501 0 0 1-8.478-2.272l-10.619-2.845 3.806-5.814 3.338-9.548Zm5.57 19.07a2.5 2.5 0 0 0 4.137 1.109l-4.136-1.108Zm8.938-25.083a10.492 10.492 0 0 0-12.62 6.673l-3.418 9.779-2.427 3.706 24.377 6.532-.248-4.423 1.93-10.178a10.492 10.492 0 0 0-7.594-12.089Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "heart_100",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.893 38.226c-2.885-2.968-7.077-2.968-9.96 0l-3.808 3.917-3.485-3.586c-2.845-2.927-7.918-2.927-10.762 0-1.79 1.842-2.184 3.924-1.67 6.19.528 2.332 2.025 4.85 4.044 7.355 3.77 4.677 9.099 9.001 12.31 11.604 3.029-2.523 8.095-6.828 11.614-11.535 1.89-2.529 3.266-5.087 3.688-7.477.412-2.33-.073-4.515-1.971-6.468Zm-11.395-1.394c3.67-3.776 9.16-3.776 12.829 0 2.39 2.46 3.019 5.313 2.507 8.21-.502 2.837-2.088 5.692-4.056 8.326-3.852 5.152-9.428 9.79-12.365 12.232l-.203.169-.632.526-.638-.519-.619-.502c-3.19-2.584-8.702-7.048-12.626-11.917-2.093-2.597-3.81-5.398-4.438-8.167-.643-2.835-.137-5.636 2.187-8.027 3.63-3.735 10-3.735 13.63 0l2.051 2.11 2.373-2.441Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close_switch",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 4 8 8M11 4l-8 8",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "ok",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.515 7.276c.546.445.646 1.273.224 1.85L4.96 17 1.3 12.47a1.369 1.369 0 0 1 .14-1.86 1.206 1.206 0 0 1 1.762.149l1.666 2.06 3.894-5.307a1.207 1.207 0 0 1 1.754-.236Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "whatsapp",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2.875C15.125 1 12.625 0 10 0 4.5 0 0 4.5 0 10c0 1.75.5 3.5 1.375 5L0 20l5.25-1.375c1.5.75 3.125 1.25 4.75 1.25 5.5 0 10-4.5 10-10 0-2.625-1.125-5.125-3-7ZM10 18.25c-1.5 0-3-.375-4.25-1.125L5.5 17l-3.125.875.875-3L3 14.5c-.875-1.375-1.25-2.875-1.25-4.375 0-4.5 3.75-8.25 8.25-8.25 2.25 0 4.25.875 5.875 2.375 1.625 1.625 2.375 3.625 2.375 5.875 0 4.375-3.625 8.125-8.25 8.125ZM14.5 12c-.25-.125-1.5-.75-1.75-.75-.25-.125-.375-.125-.5.125s-.625.75-.75 1c-.125.125-.25.125-.5.125-.25-.125-1-.375-2-1.25-.75-.625-1.25-1.5-1.375-1.75s0-.375.125-.5l.375-.375c.125-.125.125-.25.25-.375s0-.25 0-.375S7.875 6.5 7.625 6c-.125-.375-.375-.375-.5-.375h-.5c-.125 0-.375 0-.625.25S5.125 6.75 5.125 8s.875 2.375 1 2.625c.125.125 1.75 2.75 4.25 3.75 2.125.875 2.5.625 3 .625s1.5-.625 1.625-1.125c.25-.625.25-1.125.125-1.125-.125-.625-.375-.625-.625-.75Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tik_checkbox",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.414 2.014-6.831 6.7a1 1 0 0 1-1.565-.21L.633 4.408 2.36 3.402 4.1 6.386l5.914-5.8 1.4 1.428Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "union",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.805 4.264c-1.639-1.685-4.059-1.685-5.697 0l-1.546 1.59L9.18 4.43c-1.62-1.665-4.48-1.665-6.099 0C-1.033 8.662 7.71 15.5 10.785 18c2.893-2.406 11.31-9.322 7.02-13.736Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "burger",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4h18M1 10h18M1 16h18",
    stroke: "currentcolor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Vector",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2ZM0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.133 11.268V11.1c.003-.58.055-1.043.154-1.388.103-.344.252-.623.447-.835.196-.212.431-.404.706-.577.206-.132.39-.27.552-.412.163-.143.292-.3.388-.472.096-.176.144-.372.144-.587 0-.229-.054-.43-.164-.602a1.092 1.092 0 0 0-.442-.397 1.317 1.317 0 0 0-.607-.14c-.215 0-.42.048-.611.145-.193.092-.35.232-.473.417a1.28 1.28 0 0 0-.199.681H6c.017-.663.176-1.21.477-1.64a2.734 2.734 0 0 1 1.198-.97A4.095 4.095 0 0 1 9.321 4c.66 0 1.243.11 1.75.328.507.216.905.529 1.193.94.289.41.433.906.433 1.486 0 .388-.065.733-.194 1.034a2.519 2.519 0 0 1-.532.796 4.12 4.12 0 0 1-.81.621 3.286 3.286 0 0 0-.647.487c-.165.17-.29.365-.373.587a2.53 2.53 0 0 0-.124.82v.17H8.133Zm.984 3.182c-.331 0-.615-.116-.85-.348a1.144 1.144 0 0 1-.343-.845 1.122 1.122 0 0 1 .343-.835c.235-.232.519-.348.85-.348.315 0 .592.116.83.348a1.14 1.14 0 0 1 .19 1.437c-.11.179-.254.323-.433.432a1.13 1.13 0 0 1-.587.16Z",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Help",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.133 12.1v.168h1.884V12.1c.003-.324.045-.598.124-.82.083-.222.207-.418.373-.586a3.28 3.28 0 0 1 .647-.488c.311-.185.581-.393.81-.621.229-.232.406-.497.532-.796.13-.301.194-.646.194-1.034 0-.58-.144-1.075-.433-1.486a2.713 2.713 0 0 0-1.193-.94C11.564 5.11 10.981 5 10.321 5c-.6 0-1.148.108-1.646.323a2.734 2.734 0 0 0-1.198.97c-.301.43-.46.977-.477 1.64h2.028a1.28 1.28 0 0 1 .2-.68c.122-.186.28-.326.472-.418a1.35 1.35 0 0 1 .611-.145c.222 0 .424.047.607.14.185.092.333.225.442.397.11.173.164.373.164.602 0 .215-.048.41-.144.586-.096.173-.225.33-.388.473a4.69 4.69 0 0 1-.552.412c-.275.173-.51.365-.706.577-.195.212-.344.49-.447.835-.1.345-.15.807-.154 1.387ZM9.267 15.102c.235.232.519.348.85.348.212 0 .408-.053.587-.159.179-.11.323-.253.432-.432a1.14 1.14 0 0 0-.189-1.437 1.155 1.155 0 0 0-.83-.348c-.331 0-.615.116-.85.348-.232.232-.346.51-.343.835-.003.328.111.61.343.845Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z",
    fill: "currentcolor"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSprite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sprite.0b6fdb58f93226bd6be756a422424294.svg";